import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { SettingsEntrySource } from '@/analytics/enums/settings-entry.enums'
import { settingsLocationState } from '@/analytics/utils/settings-entry-analytics'
import { useRuntimeFeatureFlag } from '@/feature-flags/useRuntimeFeatureFlag'
import { RuntimeFeatureFlag } from '@/feature-flags/definitions'
import { openSettingsModal } from '@/store/slices/ui-state.slice'
import { useAppDispatch } from '@/store/store-hooks'

/**
 * Returns a callback that opens the Connected Accounts section in the settings modal
 * (SETTINGS_REVAMP_FOUNDATION on) or navigates to the legacy /dashboard/settings page (flag off).
 */
export function useOpenConnectedAccountsSettings() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { enabled } = useRuntimeFeatureFlag(RuntimeFeatureFlag.SETTINGS_REVAMP_FOUNDATION)

  return useCallback(
    (settingsEntrySource: SettingsEntrySource) => {
      if (enabled) {
        dispatch(openSettingsModal({ section: 'connected-accounts', settingsEntrySource }))
      } else {
        navigate('/dashboard/settings', { state: settingsLocationState(settingsEntrySource) })
      }
    },
    [enabled, navigate, dispatch]
  )
}
